export default function Logo() {
    return <>
        <img src="/logo-comp.jpg" className="rounded-full border-1 border-slate-500 hover:border-slate-200 transition-colors" />
    </>;
}